// Dropdown: Range
// eg. Age
// 

JLM.MD.DropdownRange = function( fieldset ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let dropdown, display_label, popout, range_min, range_min_list, range_max, range_max_list;
	
	// Settings
	let min_options = [],
		min_option_selected = null,
		max_options = [],
		max_option_selected = null;
	
	
	
	// Variables: Public ________________________________________________________
	
	INSTANCE.values = null;
	INSTANCE.value = [null, null];
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// References
		let display, display_button, footer, footer_close;
		
		// Fetch references
		dropdown = $('.dropdown_range', fieldset);
		display = $('.dd_display', dropdown);
			display_button = $('button', display);
			display_label = $('.label', display_button);
		popout = $('.dd_values', dropdown);
			range_min = $('.dd_min .dd_range_options', popout);
				range_min_list = $(' ul', range_min);
			range_max = $('.dd_max .dd_range_options', popout);
				range_max_list = $(' ul', range_max);
			footer = $('.dd_footer', popout);
			footer_close = $('button', footer);
		
		// Set values
		INSTANCE.value[0] = parseInt( dropdown.attr('data-min') );
		INSTANCE.value[1] = parseInt( dropdown.attr('data-max') );
		
		// Populate
		let values = $.trim( dropdown.attr('data-values') );
		if ( values !== '' ) {
			let values_list = values.split(',');
			populate( values_list );
		}
		
		// Events
		display_button.on('click', open);
		range_min.on('mousewheel', JLM.MT.preventScrollOverflow);
		range_max.on('mousewheel', JLM.MT.preventScrollOverflow);
		footer_close.on('click', close);
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Populate
	// 
	function populate( values ) {
		// Reset
		min_options = [];
		max_options = [];
		range_min_list.empty();
		range_max_list.empty();
		INSTANCE.value[0] = values[0];
		INSTANCE.value[1] = values[ values.length - 1 ];
		
		// Set data
		INSTANCE.values = values;
		
		// Populate
		for( let i = 0; i < INSTANCE.values.length; i++ ) {
			let value = parseInt( INSTANCE.values[i] );
			createMinOption( range_min_list, value );
			createMaxOption( range_max_list, value );
		}
		
		// Set label
		updateLabel();
	}
	
	
	// Open and Close
	// 
	function open() {
		dropdown.attr('data-status', 'open');
		setTimeout(function() {
			$('body').on('click', onClickOutside);
		}, 10);
		
		// Scroll to selected positions
		scrollToMinOption();
		scrollToMaxOption();
	}
	function close() {
		dropdown.attr('data-status', 'closed');
		$('body').off('click', onClickOutside);
	}
	function toggle() {
		if ( dropdown.attr('data-status') == 'closed' ) {
			open();
		} else {
			close();
		}
	}
	
	
	// Event Clicks
	// 
	function onClickOutside( event ) {
		if ( !$(event.target).closest( popout ).length ) {
			close();
		}
	}
	
	
	// Create options
	// 
	function createMinOption( list, value ) {
		// Settings
		const is_min_selected = ( value == INSTANCE.value[0] );
		
		// Create
		const option = new JLM.MD.DropdownRangeOption( list, value, is_min_selected );
		min_options.push( option );
		
		// States
		if ( is_min_selected ) min_option_selected = option;
		// if ( value > INSTANCE.value[1] ) option.hide();
		
		// Events
		option.on('select', function( value ) {
			min_option_selected.deselect();
			min_option_selected = option;
			INSTANCE.value[0] = value;
			
			if ( INSTANCE.value[0] > INSTANCE.value[1] ) {
				for( let i = 0; i < max_options.length; i++ ) {
					let option = max_options[i];
					if ( option.value == INSTANCE.value[0] ) {
						max_option_selected.deselect();
						max_option_selected = option;
						option.select();
						INSTANCE.value[1] = INSTANCE.value[0];
						break;
					}
				}
			}
			
			updateLabel();
			scrollToMaxOption();
			INSTANCE.dispatchEvent('change', [ INSTANCE.value ]);
		});
	}
	function createMaxOption( list, value ) {
		// Settings
		const is_max_selected = ( value == INSTANCE.value[1] );
		
		// Create
		const option = new JLM.MD.DropdownRangeOption( list, value, is_max_selected );
		max_options.push( option );
		
		// States
		if ( is_max_selected ) max_option_selected = option;
		// if ( value < INSTANCE.value[0] ) option.hide();
		
		// Events
		option.on('select', function( value ) {
			max_option_selected.deselect();
			max_option_selected = option;
			INSTANCE.value[1] = value;
			
			if ( INSTANCE.value[1] < INSTANCE.value[0] ) {
				for( let i = 0; i < min_options.length; i++ ) {
					let option = min_options[i];
					if ( option.value == INSTANCE.value[1] ) {
						min_option_selected.deselect();
						min_option_selected = option;
						INSTANCE.value[0] = INSTANCE.value[1];
						option.select();
						break;
					}
				}
			}
			
			updateLabel();
			scrollToMinOption();
			INSTANCE.dispatchEvent('change', [ INSTANCE.value ]);
		});
	}
	
	
	// Keep min option fixed to top of list
	// 
	function scrollToMinOption() {
		let scroll_min = min_option_selected.getPositionTop();
		range_min.scrollTop( scroll_min );
	}
	
	// Keep max option fixed to bottom of list
	// 
	function scrollToMaxOption() {
		let scroll_max = max_option_selected.getPositionTop() - ( range_min.height() - max_option_selected.height() );
		range_max.scrollTop( scroll_max );
	}
	
	
	// Update the display label
	// 
	function updateLabel() {
		if ( INSTANCE.value[0] == INSTANCE.value[1] ) {
			display_label.html('Around ' + INSTANCE.value[0]);
		} else {
			display_label.html('Between ' + INSTANCE.value[0] + '–' + INSTANCE.value[1]);
		}
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	// Set new values for the dropdown
	// 
	INSTANCE.set = function( values ) {
		populate( values );
	};
	
	
	// Checks if currently selected values are min and max
	// 
	INSTANCE.isLimits = function() {
		return ( INSTANCE.value[0] == INSTANCE.values[0] && INSTANCE.value[1] == INSTANCE.values[INSTANCE.values.length - 1] );
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};